import { gql } from "@apollo/client"

export const CHANGE_PASSWORD_AUTH_MUTATION = gql`
  mutation UserPasswdUpdate($UserPasswdUpdateInput: UserPasswdUpdateInput!) {
    UserPasswdUpdate(input: $UserPasswdUpdateInput) {
      status {
        success
        name
        detail
      }
      user {
        Person {
          id
          fullName
        }
      }
    }
  }
`
